(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
    function waitForElm(selector) {
      return new Promise(resolve => {
          if (document.querySelector(selector)) {
              return resolve(document.querySelector(selector));
          }

          const observer = new MutationObserver(mutations => {
              if (document.querySelector(selector)) {
                  resolve(document.querySelector(selector));
                  observer.disconnect();
              }
          });

          observer.observe(document.body, {
              childList: true,
              subtree: true
          });
      });
  }
    
  waitForElm('.product-recommendations .product-block').then((elm) => {
    
    console.log('recommendation loaded')
      setTimeout(function() {
            if (typeof window.yotpoWidgetsContainer !== "undefined") {
            console.log('init yotpo')
            window.yotpoWidgetsContainer.initWidgets();
          }
        }, 800)
  });

  } catch(e) { console.error(e); }
})();
})();
